import {MenuItem} from "@mui/material";
import {GlassConstants} from "../../utils/GlassConstants.js";
import GlassContextMenu from "./GlassContextMenu.js";
import React, {useEffect, useRef} from "react";
import {useContextMenu} from "../../hooks/ContextMenuHook.js";

export default function SubMenuItem({item, index, hoveredIndex, setHoveredIndex, parentMenuId})
{

    const submenuItems = item.subMenu.items ?? [];
    const {openMenu, closeMenu, isMenuOpen, getMenuPosition} = useContextMenu();
    const timeoutRef = useRef(null);
    const submenuId = `${item.action}-submenu`;
    const menuItemRef = useRef(null);
    const positionRef = useRef(null);

    const handleMouseEnter = (e) =>
    {
        setHoveredIndex(index);

        if (timeoutRef.current)
        {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }

        // Only set position once when first opening
        if (!isMenuOpen(submenuId))
        {
            const rect = e.currentTarget.getBoundingClientRect();

            positionRef.current = {
                mouseX: rect.right,
                mouseY: rect.top,
            };
            // Pass parentMenuId here!
            openMenu(submenuId, positionRef.current, parentMenuId);
        }
    };

    const handleMouseLeave = () =>
    {
        // Only start closing if not moving to submenu
        timeoutRef.current = setTimeout(() =>
        {
            // Only unhover if submenu is actually closed
            if (!isMenuOpen(submenuId))
            {
                setHoveredIndex(null);
            }
            closeMenu(submenuId);
            positionRef.current = null;
        }, 150);
    };

    const handleSubmenuMouseEnter = () =>
    {
        // Keep parent highlighted - DON'T clear this
        setHoveredIndex(index);

        if (timeoutRef.current)
        {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };

    const handleSubmenuMouseLeave = () =>
    {
        // Now we can unhover
        setHoveredIndex(null);
        closeMenu(submenuId);
        positionRef.current = null;
    };

    useEffect(() =>
    {
        return () =>
        {
            if (timeoutRef.current)
            {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const mergedSx = {
        ...GlassConstants.sx(hoveredIndex, index),
        fontSize: '1em !important',
        fontWeight: hoveredIndex === index ? 500 : 400,
        ...(isMenuOpen(submenuId) && {
            borderTopRightRadius: '0 !important',
            borderBottomRightRadius: '0 !important',
        })
    };

    return (
        <>
            <MenuItem
                ref={menuItemRef}
                key={item.action || index}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                sx={mergedSx}
            >
                {item.label} ›
            </MenuItem>
            <div
                onMouseEnter={handleSubmenuMouseEnter}
                onMouseLeave={handleSubmenuMouseLeave}
                style={{
                    position: 'fixed',
                    pointerEvents: isMenuOpen(submenuId) ? 'auto' : 'none',
                }}
            >
                <GlassContextMenu
                    key={submenuId}
                    menuId={submenuId}
                    items={submenuItems}
                    contextMenu={isMenuOpen(submenuId) ? getMenuPosition(submenuId) : null}
                    onClose={() =>
                    {
                        closeMenu(submenuId);
                        positionRef.current = null;
                    }}
                    isMerged={true}
                />
            </div>
        </>
    );
}